import { render } from "./Socials.vue?vue&type=template&id=9ab735c2&ts=true"
import script from "./Socials.vue?vue&type=script&lang=ts"
export * from "./Socials.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__